import { ScrollArea } from '@/components/ui/scroll-area';
import { Bus, Clock, RefreshCw, ExternalLink } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BusInfoSection = () => {
  const [busServices, setBusServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  const fetchBusData = async () => {
    try {
      const busesRes = await axios.get(`${API}/buses`);
      if (busesRes) setBusServices(busesRes.data);
      setLastUpdate(new Date());
      setLoading(false);
    } catch (error) {
      console.error('Error fetching bus data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBusData();
  }, []);

  return (
    <div className="content-card content-card-large" data-testid="bus-section">
      <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>
          <Bus size={20} className="inline" /> Lynx Buses
        </h2>
        <Button 
          onClick={fetchBusData} 
          variant="ghost" 
          size="sm"
          style={{ padding: '0.4rem 0.8rem' }}
          data-testid="refresh-bus-button"
        >
          <RefreshCw size={14} />
        </Button>
      </div>
      <ScrollArea className="card-content">
        <div className="transport-container">
          {/* Live Bus Tracker */}
          <div className="transport-subsection">
            <div className="transport-subsection-header">
              <Bus size={18} />
              <h3>Live Bus Tracker - West Norfolk</h3>
              <a 
                href="https://bustimes.org/operators/lynx/map" 
                target="_blank" 
                rel="noopener noreferrer"
                className="header-external-link"
                title="Open in new tab"
              >
                <ExternalLink size={16} />
              </a>
            </div>
            <div className="live-embed-container">
              <iframe
                src="https://bustimes.org/operators/lynx/map"
                width="100%"
                height="500"
                title="Lynx Bus Live Tracker"
                className="transport-iframe"
              />
            </div>
          </div>

          {/* Bus Routes Summary */}
          <div className="transport-subsection">
            <div className="transport-subsection-header">
              <Bus size={18} />
              <h3>Popular Routes from King's Lynn</h3>
            </div>
            {loading ? (
              <p className="loading-text">Loading bus routes...</p>
            ) : (
              <div className="bus-routes-list">
                {busServices.slice(0, 6).map((bus, index) => (
                  <div key={`${bus.route}-${bus.destination}`} className="bus-route-item" data-testid={`bus-${index}`}>
                    <div className="bus-route-badge">{bus.route}</div>
                    <div className="bus-route-info">
                      <span className="bus-destination">{bus.destination}</span>
                      <span className="bus-operator">{bus.operator}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Quick Links */}
          <div className="transport-quick-links">
            <a 
              href="https://www.gtt-online.co.uk/bus-tracker/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="quick-link-btn"
            >
              Alternative Tracker
            </a>
            <a 
              href="https://bustimes.org/localities/king-s-lynn" 
              target="_blank" 
              rel="noopener noreferrer"
              className="quick-link-btn"
            >
              Full Timetables
            </a>
          </div>

          <div className="transport-update-time">
            <Clock size={14} />
            <span>Routes updated: {lastUpdate.toLocaleTimeString()}</span>
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};

export default BusInfoSection;